export default "__VITE_ASSET__BiTeX5hv__"